import type { ISidebarNavIndicatorProps } from './types';

import style from './styles.module.scss';

const SidebarNavIndicator = ({ top = 0, height = 0 }: ISidebarNavIndicatorProps) => {
  return (
    <span
      className={style['nav-indicator']}
      style={{
        top: `${top}px`,
        height: `${height}px`,
      }}
      aria-hidden="true"
    />
  );
};

export default SidebarNavIndicator;
